import axios from 'axios'

export function getOrderSummary(id: number) {
  return axios.get(`/api/payment/order/summary/${id}`)
}
